import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ResourceService } from 'src/app/services/resource/resource.service';


@Component({
  selector: 'app-knowledge-base-search',
  templateUrl: './knowledge-base-search.component.html',
  styleUrls: ['./knowledge-base-search.component.css']
})
export class KnowledgeBaseSearchComponent implements OnInit {


  Submitted: boolean = false;
  KnowledgeBaseList:any;

  
  constructor(private resourceService: ResourceService, private LookupService: LookupService,
     public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }


  
  SearchModel={
    ResourceType:'0'
  }

  GetAllKnowledgeBase() {
    this.spinnerService.show();
    this.resourceService.GetAllKnowledgeBase(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.KnowledgeBaseList = data.KnowledgeBaseList;     
      this.spinnerService.hide();
    });

  }

  
  ngOnInit() {
   this.GetAllKnowledgeBase();
  }

  
  

}



